import React, { Fragment, useState } from "react";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { cs } from 'shared/utils/classnames';

export function PasswordInput ({
  label,
  value,
  placeholder,
  name,
  onChange,
  required,
  error,
  disabled
} : {
  label?: string,
  value: string,
  placeholder?: string,
  name?: string,
  onChange: (value: string, e: React.ChangeEvent<HTMLInputElement>) => any,
  required?: boolean,
  error?: string,
  disabled?: boolean
}) {
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value, e);
  };
  const className = cs('border bg-gray-100 rounded-md w-full py-2 px-4 text-lg font-light', {
    'border-red-200': !!error,
    'border-[#F5F5F5]': !error,
    'opacity-50': disabled
  });
  return (
    <Fragment>
      {label ? <div className="text-base text-gray-800 font-medium mb-1">{label}</div> : null}
      <div className="w-full relative">
        <input
          className={className}
          type={`${showPassword ? "text" : "password"}`}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          required={required}
          autoComplete="off"
          disabled={disabled}
        />
        <div
          className="absolute right-3 top-0 h-full flex items-center cursor-pointer"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <Visibility fill="#909090" />
          ) : (
            <VisibilityOff fill="#909090" />
          )}
        </div>
      </div>
      <div className="text-red-500 text-sm mb-2 min-h-[20px]">{error}</div>
    </Fragment>
  )
}